// Функция для проверки прав пользователя
// Что бы блокировать доступ к элементам/функционалу для которых нужны определенные права
export default function checkPermission(permission, permissions = []) {
  // Если permissions передан, используем его; иначе парсим из токена
  let userPermissions

  if (Array.isArray(permissions) && permissions.length) {
    userPermissions = permissions
  } else {
    const token = localStorage.getItem('token')
    if (!token) {
      return false
    }
    userPermissions = parseJwt(token)?.permissions
    if (!userPermissions || !Array.isArray(userPermissions)) {
      return false // Доп проверка на валидность
    }
  }

  // Проверка для массива permission (все должны быть)
  if (Array.isArray(permission)) {
    return permission.every(perm => userPermissions.includes(perm))
  }

  // Проверка для одиночного permission
  return userPermissions.includes(permission)
}

export const hasPermission = (permission) => {
  const lookupStore = useLookupStore()
  const {permissions} = storeToRefs(lookupStore)

  return permissions.value.includes(permission)
}